import React from 'react';
import {
  makeStyles,
  FormControl,
  Select,
  MenuItem,
  FormLabel,
} from '@material-ui/core';
import {
  TEpDevPEntityId
} from '@solace-labs/backstage-plugin-ep-devp-common';
import {
  EpDevPSearchContextValue,
  useEpDevPSearch
} from '../../context';
import { useServiceRegistryTranslation } from '../../../../../i18n/ServiceRegistryLanguageProvider';

const useStyles = makeStyles(
  theme => ({
    label: {
      textTransform: 'capitalize',
      marginBottom: theme.spacing(1.5),
    },
  }),
);

export interface IEpDevPSearchFilterSelectProps {
  className?: string;
  title?: string;
  searchFieldName: string;
  valuesEntityIdList: Array<TEpDevPEntityId>;
}

export const EpDevPSearchFilterSelect = (props: IEpDevPSearchFilterSelectProps) => {
  const { t } = useServiceRegistryTranslation();

  const classes = useStyles();
  const { className, title, valuesEntityIdList } = props;

  const useSearchContext: EpDevPSearchContextValue = useEpDevPSearch();

  const handleChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const {
      target: { value },
    } = e;
    useSearchContext.setDomainIds(value ? [value as string] : undefined);
  };

  return (
    <FormControl
      className={className}
      fullWidth
      size="small"
      data-testid="search-selectfilter-next"
    >
      {title && (
        <FormLabel classes={{ root: classes.label }}>{title}</FormLabel>
      )}
      <Select
        value={useSearchContext.filters.domainIds?.[0] ?? ''}
        variant="outlined"
        onChange={handleChange}
      >
        <MenuItem key="_all" value=''><em>{t('developerSearch.all')}</em></MenuItem>
        {valuesEntityIdList.map(item => (
          <MenuItem key={item.id} value={item.id}>
            {item.displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
